<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue';

const wrapper = ref<HTMLElement | null>(null);
let resizeObserver: ResizeObserver | null = null;

const height = ref('0');

watch(
  wrapper,
  (wrapper) => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }

    if (wrapper) {
      resizeObserver = new ResizeObserver((entries) => {
        const h = entries[0].contentRect.height;
        height.value = h ? `${h}px` : '0';
      });
      resizeObserver.observe(wrapper);
    }
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
    resizeObserver = null;
  }
});
</script>

<template>
  <div :class="$style.root">
    <div ref="wrapper"><slot></slot></div>
  </div>
</template>

<style lang="scss" module>
.root {
  height: v-bind('height');

  > div {
    position: fixed;
    z-index: $zindex-fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
